const mEditionBillingMyChargesDropDownFilters = {
  mEditionBillingMyChargesDropDownFilters: {
    input: {
      estado: {
        label: 'Estados de Comprobantes',

        cancelado: {
          label: 'Cancelados'
        },

        cobrado: {
          label: 'Cobrados'
        },

        pendiente: {
          label: 'Pendientes'
        },

        reembolso: {
          label: 'Reembolsados'
        }
      },
      tipos: {
        label: 'Tipos de Comprobantes'
      },

      divisa: {
        label: 'Moneda'
      },

      medioPago: {
        label: 'Medios de Pago'
      },

      email: {
        label: 'Email',
        placeholder: 'alumno@email.com'
      },

      pais: {
        label: 'País'
      },

      fecha: {
        label: 'Fecha',

        desde: {
          placeholder: 'Desde - dd/mm/aaaa'
        },
        hasta: {
          placeholder: 'Hasta - dd/mm/aaaa'
        }
      },

      descuento: {
        label: 'Código de Descuento'
      }
    },

    buttons: {
      btnReiniciarText: 'REINICIAR',
      btnFilterText: 'FILTRAR'
    }
  }
}

export default mEditionBillingMyChargesDropDownFilters
